import { render, staticRenderFns } from "./PremiosRuleta.vue?vue&type=template&id=6b074b01&"
import script from "./PremiosRuleta.vue?vue&type=script&lang=js&"
export * from "./PremiosRuleta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports